import React, { useState } from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState<boolean>(false);

  const handleSidebarToggle = (expanded: boolean) => {
    setIsSidebarExpanded(expanded);
  };

  return (
    <Box sx={{ bgcolor: '#f0f0f0', minHeight: '100vh' }}>
      <div className="dashboard-container">
        <Sidebar onToggle={handleSidebarToggle} />

        <Box
          className="main-content"
          sx={{
            ml: '2px',
            transition: 'margin-left 0.3s ease',
            width: `calc(100% - ${isSidebarExpanded ? '250px' : '70px'})`,
            overflow: 'auto',
          }}
        >
          <div className="dashboard-content">{children}</div>
        </Box>
      </div>
    </Box>
  );
};

export default Layout;
